// extracted by mini-css-extract-plugin
export default {"component":"lSd3a"};